import { Button, Color, Flex, Icon, SectionMessage, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoiceStatus } from '@features/eInvoicing/constants/eInvoiceStatus'
import { EInvoicingReasonLabelSkeleton } from '@features/eInvoicing/elements/EInvoicingReasonLabelSkeleton'
import { useGetEInvoiceReasonLabel } from '@features/eInvoicing/hooks/useGetEInvoiceReasonLabel'

import * as Styled from './styles'

interface BillEInvoiceLifecycleBannerProps {
  status: EInvoiceStatus.Disputed | EInvoiceStatus.Suspended
  eInvoiceId: string | undefined
  reasonCode: string | null
  onChangeStatus: () => void
}

const STATUS_I18N_KEY: Record<EInvoiceStatus.Disputed | EInvoiceStatus.Suspended, string> = {
  [EInvoiceStatus.Disputed]: 'bill.view.form.disputed_info',
  [EInvoiceStatus.Suspended]: 'bill.view.form.suspended_info',
}

export const BillEInvoiceLifecycleBanner = ({
  status,
  eInvoiceId,
  reasonCode,
  onChangeStatus,
}: BillEInvoiceLifecycleBannerProps): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, reasonLabel } = useGetEInvoiceReasonLabel({ status, eInvoiceId, reasonCode })
  const isResolvingReason = isLoading && !!reasonCode && !reasonLabel

  return (
    <>
      <SectionMessage showIcon={false} variant="warning">
        <Flex alignItems="center" gap={Spacing.S12}>
          <Icon color={Color.Black} icon="info" size="lg" />
          {isResolvingReason ? (
            <EInvoicingReasonLabelSkeleton />
          ) : (
            <Text>{t(STATUS_I18N_KEY[status], { reason: reasonLabel ?? reasonCode })}</Text>
          )}
          <Styled.ChangeStatusButtonWrapper>
            <Button color="warning" onClick={onChangeStatus} size="md" variant="onColor">
              {t('bill.action.change_status')}
            </Button>
          </Styled.ChangeStatusButtonWrapper>
        </Flex>
      </SectionMessage>
      <Space />
    </>
  )
}
